var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.user.groups.includes('administrators'))?_c('div',[_c('LoadClient')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }